import { styled } from "@mui/material/styles";

export const CaseBufferLegend = styled("div")`
  width: 20px;
  height: 20px;
  border: 2px solid #7C6EE6;
  background-color: #7c6ee64e;
`;
